import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CaseSearch } from '../beans/CaseSearch';
import { urlLinks } from '../utility/url-links';
import { HttpService } from './http.service';

@Injectable()
export class ReportService {

	constructor(private http: HttpService) { }

	executeXLSReport(search: CaseSearch): Observable<HttpResponse<Blob>> {
		console.log('[ReportService] executeXLSReport with:', search);
		return this.http.postBlob(
			urlLinks.rest.report.executeReport,
			search
		);
	}

	executeXLSReportTrauma(search: CaseSearch): Observable<HttpResponse<Blob>> {
		console.log('[ReportService] executeXLSReportTrauma with:', search);
		return this.http.postBlob(
			urlLinks.rest.report.executeReportTrauma,
			search
		);
	}

	executeNasrocheniXLSReport(isExtended: boolean): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeNasrocheniReport}?isExtended=${isExtended}`;
		console.log('[ReportService] executeNasrocheniXLSReport:', url);

		// тук нямаш реално тяло, но POST изисква body → даваме null
		return this.http.postBlob(url, null);
	}

	executeCalendarXLSReport(year: number, month: number, isExtended: boolean): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeCalendarReport}?year=${year}&month=${month}&isExtended=${isExtended}`;
		return this.http.postBlob(url, null);
	}

	executeNewCasesReport(from: string, to: string): Observable<HttpResponse<Blob>> {
		const url = `${urlLinks.rest.report.executeNewCasesReport}?from=${from}&to=${to}`;
		return this.http.postBlob(url, null);
	}
}
